// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3a19923d","453":"09e43f8a","667":"fcb59750"}[chunkId] + ".chunk.js";
};